import PropTypes from 'prop-types'
import React from 'react'

import { H4, TextLH } from 'styles/components/typography'

import DynamicImage from '../DynamicImage'

import {
  Wrapper,
  Icon,
  Content,
  ContentBlock,
  IconBlock,
  AsideImageBox,
} from './styles'

const TooltipInfo = ({ data, asideImage }) => {
  return (
    <Wrapper>
      {asideImage && (
        <AsideImageBox>
          <DynamicImage {...asideImage} alt={''} />
        </AsideImageBox>
      )}
      {data.map((row, index) => (
        <Content key={index}>
          <IconBlock isEmpty={!row.icon}>
            <Icon src={row.icon} draggable={false} alt="" />
          </IconBlock>
          <ContentBlock>
            <H4 dangerouslySetInnerHTML={{ __html: row.title }} />
            <TextLH dangerouslySetInnerHTML={{ __html: row.descr }} />
          </ContentBlock>
        </Content>
      ))}
    </Wrapper>
  )
}

TooltipInfo.propTypes = {
  /** Object with texts for subscription */
  data: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      descr: PropTypes.string.isRequired,
      icon: PropTypes.string,
    }),
  ).isRequired,
  asideImage: PropTypes.shape({
    image: PropTypes.string,
    imageType: PropTypes.string,
    imageSizes: PropTypes.object,
  }),
}

export default TooltipInfo
